import axios from 'axios';
import { studentsDomain } from './domain';
import { clearStoredAuth, getStoredToken } from './authStorage';
import { isAuthFreePath } from './authFreePaths';

// Create axios instance with default config
const axiosInstance = axios.create({
    baseURL: `${studentsDomain}/api`,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true // Enable sending cookies with requests
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = getStoredToken();
        if (token && !config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors and network issues
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Network error (no response from server)
        if (!error.response) {
            // Dispatch a custom event that will be caught by NetworkProvider
            window.dispatchEvent(new CustomEvent('network-error'));
            return Promise.reject(error);
        }

        // Handle 401 Unauthorized
        if (error.response?.status === 401) {
            // Clear auth data on unauthorized
            clearStoredAuth();
            // Redirect to login if not already on a public auth page
            if (!isAuthFreePath(window.location.pathname)) {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance; 